import styled, { css } from 'styled-components';
import { AdditionalCostCorrectionDetailsDto, AdditionalCostDetailsDto, ChildId } from 'types';
import { ParentAdditionalCostCorrectionItem } from './ParentAdditionalCostCorrectionItem/ParentAdditionalCostCorrectionItem';
import { ParentAdditionalCostItem } from './ParentAdditionalCostItem/ParentAdditionalCostItem';

export const BillDetailsContainer = styled.div`
    ${({ theme }) => css`
        padding: 16px;
        display: grid;
        grid-template-columns: 1fr;
        gap: 1rem;
        border: 1px solid ${theme.colors.primary.primary5};
        border-radius: 10px;
    `}
`;

type Props = {
    childId: ChildId;
    detailsDto: AdditionalCostDetailsDto;
    corrections: Array<AdditionalCostCorrectionDetailsDto>;
    index: number;
};

export const ParentAdditionalCostPackage = ({ childId, detailsDto, corrections, index }: Props) => {
    return (
        <BillDetailsContainer>
            {corrections?.map((correction) => {
                return (
                    <ParentAdditionalCostCorrectionItem
                        childId={childId}
                        correction={correction}
                        detailsDto={detailsDto}
                        index={index}
                    />
                );
            })}

            <ParentAdditionalCostItem childId={childId} detailsDto={detailsDto} index={index} />
        </BillDetailsContainer>
    );
};
